import React from 'react';
import autoBind from 'auto-bind';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SemanticToastContainer } from 'react-semantic-toasts';
import { Button, Container, Header, Icon } from 'semantic-ui-react';
import {
  getDiscountRules,
  showCreateDiscountRuleModal,
  showEditDiscountRuleModal,
  showDeleteConfirmationModal,
  setEditorErrorMessage,
  doShowLogs,
  setLogModalShown,
  setLogPage,
} from 'state/discountRule/actions';
import LogModal from 'components/LogModal';
import DiscountRulesList from './DiscountRulesList';
import DiscountRuleEditorModal from './DiscountRuleEditorModal';
import DeleteDiscountRuleModal from './DeleteDiscountRuleModal';

export class DiscountRulesPage extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getDiscountRules());
  }

  onCreateButtonClicked() {
    const { dispatch } = this.props;
    dispatch(setEditorErrorMessage(null));
    dispatch(showCreateDiscountRuleModal(true));
  }

  onEditRule(rule) {
    const { dispatch } = this.props;
    dispatch(setEditorErrorMessage(null));
    dispatch(showEditDiscountRuleModal(true, rule));
  }

  onDeleteRule(rule) {
    const { dispatch } = this.props;
    dispatch(showDeleteConfirmationModal(true, rule));
  }

  onShowLogButtonClicked() {
    const { dispatch } = this.props;
    dispatch(doShowLogs());
  }

  render() {
    const { discountRules, isLoading, editor, dispatch, log } = this.props;

    return (
      <Container style={{ marginTop: '2em' }}>
        <SemanticToastContainer position="top-right" />

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '1em',
          }}
        >
          <div>
            <Header as="h1" style={{ marginBottom: '0.2em' }}>
              Renewal Discount
            </Header>
            <p style={{ color: '#666', margin: 0 }}>
              Configure renewal discounts based on remaining subscription period
            </p>
          </div>
          <div>
            <Button
              basic
              color="black"
              onClick={this.onShowLogButtonClicked}
              style={{ marginRight: '0.5em' }}
            >
              Show Logs
            </Button>
            <Button
              primary
              icon
              labelPosition="left"
              onClick={this.onCreateButtonClicked}
            >
              <Icon name="plus" />
              Create Discount
            </Button>
          </div>
        </div>
        <Header as="h3" style={{ marginBottom: '0.5em' }}>
          Discount Rules
        </Header>
        <DiscountRulesList
          discountRules={discountRules}
          isLoading={isLoading}
          onEditRule={this.onEditRule}
          onDeleteRule={this.onDeleteRule}
        />
        <div
          style={{
            marginTop: '1.5em',
            padding: '1em 1.2em',
            background: '#f9fafb',
            borderRadius: '6px',
            border: '1px solid rgba(34,36,38,.1)',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.8em',
          }}
        >
          <Icon
            name="percent"
            size="large"
            style={{ marginTop: '0.1em', color: '#888' }}
          />
          <div>
            <strong>How Renewal Discounts Work</strong>
            <ul
              style={{
                margin: '0.4em 0 0',
                paddingLeft: '1.2em',
                color: '#555',
              }}
            >
              <li>
                Discounts are applied when merchant&apos;s remaining
                subscription ≤ configured months
              </li>
              <li>
                Each &quot;Months Left&quot; value must be unique across all
                renewal discounts
              </li>
            </ul>
          </div>
        </div>
        <DiscountRuleEditorModal
          isOpen={editor.isOpen}
          isEditMode={editor.isEditMode}
          editingRule={editor.editingRule}
          isLoading={editor.isLoading}
          errorMessage={editor.errorMessage}
          errors={editor.errors || []}
        />
        <LogModal
          title="Discount Rules Logs"
          shown={log.shown}
          data={log.data}
          paging={log.paging}
          isLoading={log.isLoading}
          errors={log.errors}
          onPageChange={page => dispatch(setLogPage(page))}
          onClose={() => dispatch(setLogModalShown(false))}
        />
        <DeleteDiscountRuleModal />
      </Container>
    );
  }
}

DiscountRulesPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  discountRules: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      discount_percentage: PropTypes.number,
    })
  ).isRequired,
  isLoading: PropTypes.bool.isRequired,
  editor: PropTypes.shape({
    isOpen: PropTypes.bool,
    isEditMode: PropTypes.bool,
    editingRule: PropTypes.object,
    isLoading: PropTypes.bool,
    errorMessage: PropTypes.string,
    errors: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  log: PropTypes.shape({
    shown: PropTypes.bool.isRequired,
    data: PropTypes.array.isRequired,
    paging: PropTypes.shape({
      page: PropTypes.number.isRequired,
      size: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired,
    }).isRequired,
    isLoading: PropTypes.bool.isRequired,
    errors: PropTypes.array.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  discountRules: state.discountRule.discountRules,
  isLoading: state.discountRule.isLoading,
  editor: state.discountRule.editor,
  log: state.discountRule.log,
});

export default connect(mapStateToProps)(DiscountRulesPage);
